"use client";

import type { NavActionCtaData } from "@homeinstead/shared/site-builder";

import { cn } from "../../utils/classnames";
import { NavActionCta } from "./NavActionCta";

type NavigationBottomPanelProps = {
  phoneNumber: string;
  scrolledPastViewport: boolean;
  /**
   * The resolved sticky CTA for the small viewport. When set, the panel
   * renders this CTA in the small-viewport-only bottom-sticky slot. When null,
   * the panel renders nothing — the slot is removed from the layout,
   * not hidden — so callers can pass the resolver's nullable result
   * directly without an extra ternary wrapper at every consumer.
   */
  stickyCta: NavActionCtaData | null;
};

function NavigationBottomPanel({
  phoneNumber,
  scrolledPastViewport,
  stickyCta,
}: NavigationBottomPanelProps) {
  if (!stickyCta) {
    return null;
  }

  return (
    <div
      aria-hidden={!scrolledPastViewport}
      className={cn(
        "fixed bottom-0 z-[100] flex w-full translate-y-0 items-center justify-center bg-support-tints-400 p-4 pr-[var(--chat-widget-mobile-slot-width,0px)] pl-4 md:hidden",
        scrolledPastViewport
          ? "motion-safe:animate-fade-in-up"
          : "pointer-events-none translate-y-8 opacity-0",
      )}
      inert={!scrolledPastViewport ? true : undefined}
    >
      <NavActionCta
        cta={stickyCta}
        phoneNumber={phoneNumber}
        placement="bottom sticky"
      />
    </div>
  );
}

export { NavigationBottomPanel };
